import React from 'react';
import IconeSobrescrito from './IconeSobrescrito';
import {
    Warning
} from '@mui/icons-material';

interface IPropsIconeWarningSobrescrito {
}


export default class IconeWarningSobrescrito extends React.Component<IPropsIconeWarningSobrescrito> {


    render() {
        return (
            <IconeSobrescrito>
                <Warning />
            </IconeSobrescrito>
        );
    }
}
